import { graphql, PageProps } from 'gatsby'
import React from 'react'

import { Account } from '../../components/shop/account/Account'
import { AccountDashboardPageQuery } from '../../graphql/gatsby'

const AccountRoute: React.FC<PageProps<AccountDashboardPageQuery>> = ({ data }) => {
  return <Account sanityAccountDashboardPage={data.sanityAccountDashboardPage} />
}

// NOTE: keep this query synchronized with the one in ../u/[slug]/account/[...].tsx
export const query = graphql`
  query AccountDashboardPage {
    ...sanityAccountDashboardPage
  }
`

export const sanityAccountDashboardPageFragment = graphql`
  fragment sanityAccountDashboardPage on Query {
    sanityAccountDashboardPage(_id: { regex: "/(drafts.|)accountDashboardPage/" }) {
      content {
        __typename
        ...sanityFeaturedProductsBanner
      }
    }
  }
`

export default AccountRoute
